<template>
  <b-navbar toggleable="md" type="dark" variant="dark">
    <b-navbar-toggle target="nav-text-collapse"></b-navbar-toggle>

    <b-navbar-brand href="/">
      <img src="/datacatalog-simple/images/logo-white.png" alt="Logo" />
    </b-navbar-brand>

    <b-collapse id="nav-text-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item v-if="isAuthenticated" :to="{ name: 'home' }">Home</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item v-if="isAuthenticated" :to="{ name: 'dataCatalog' }">Data Catalog</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item v-if="isAuthenticated" :to="{ name: 'wikipedia' }">Wikipedia</b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item-dropdown
          :class="[$route.path.includes('/analytics-2-livello/d-') ? 'active-dropdown' : '']"
          v-if="isAuthenticated"
          text="Analytics 2° livello"
        >
          <template slot="button-content">
            <span class="dropdown-text">Analytics 2° livello</span>
          </template>
          <b-dropdown-item :to="{ name: 'opinionMining' }">Opinion Mining</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'twittersfera' }">Twittersfera</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'communityTopics' }">Community & Topics</b-dropdown-item>
          <b-dropdown-item :to="{ name: 'peakDetection' }">Peak Detection</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-navbar-nav>
          <b-nav-item v-if="isAuthenticated" :to="{ name: 'destinations' }">Analisi statistiche</b-nav-item>
        </b-navbar-nav>
      </b-navbar-nav>
      <b-navbar-nav>
        <b-nav-item v-if="!isAuthenticated" :to="{ name: 'signIn' }">Accedi</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav>
        <b-nav-item v-if="isAuthenticated" :to="{ name: 'cubejsApi' }">API</b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown
          :class="[$route.path.includes('/profile/') ? 'active-dropdown' : '']"
          v-if="isAuthenticated"
          right
        >
          <template slot="button-content">
            <strong class="nav-username dropdown-text">{{ user }}</strong>
          </template>
          <b-dropdown-item :to="{ name: 'manageApiKeys' }">
            <span class="nav-username">Gestione API</span>
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'changePassword' }">
            <span class="nav-username">Cambia password</span>
          </b-dropdown-item>
          <b-dropdown-item :to="{ name: 'signOut' }">
            <span class="nav-username">Esci</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
/*
  The main navbar of the website
*/

import { mapState } from 'vuex'

export default {
  name: 'Navbar',
  computed: {
    ...mapState({
      user: state => state.auth.user,
      isAuthenticated: state => state.auth.isAuthenticated
    })
  }
}
</script>

<style scoped>
.navbar {
  z-index: 1;
}

.navbar-brand img {
  width: 50px;
}

@media screen and (min-width: 992px) {
  .navbar {
    padding-top: 0;
    padding-bottom: 0;
  }

  .nav-username {
    padding-left: 0.5em;
    padding-right: 0.5em;
  }
}
</style>
